var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('global-header'), _vm._v(" "), _c('div', {
    staticClass: "main-visual-wrap"
  }, [_c('div', {
    ref: "mainImage",
    staticClass: "main-visual"
  }, [_vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": require("../assets/images/img_main.png")
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 320px)",
      "srcset": require("../assets/images/img_main@sp.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mainVisual",
    attrs: {
      "src": require("../assets/images/img_main@sp.png"),
      "alt": "東村アキコメインビジュアル"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main001",
    attrs: {
      "data-aos": "flip-left",
      "data-aos-delay": "500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_main001.svg"),
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "main002",
    attrs: {
      "data-aos": "zoom-out-up",
      "data-aos-delay": "1000"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_main002.png"),
      "alt": "東村アキコのみそ鍋革命"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main003",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-delay": "1500"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_main003.png"),
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main004",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1300"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_main004.png"),
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main005",
    attrs: {
      "data-aos": "zoom-in-up",
      "data-aos-delay": "1900"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_main005.svg"),
      "alt": ""
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd89b1b","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainVisual.vue
// module id = 41
// module chunks = 0